import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CurrencySwitcher from './CurrencySwitcher';
import LanguageSwitcher from './LanguageSwitcher';
import NotificationBell from './NotificationBell';
import ProfileMenu from './ProfileMenu';
import { useAuth } from '../../hooks/useAuth';
import { useSubscription } from '../../contexts/SubscriptionContext';

function Header() {
  const { t } = useTranslation('common');
  const { t: tSub } = useTranslation('subscription');
  const { role, isPro } = useAuth();
  const { openUpgradeModal } = useSubscription();
  const showUpgradePill = role === 'user' && !isPro;

  return (
    <header className="app-header">
      <Link to="/" className="app-brand">
        <img src="/logo-icon.png" alt="" className="app-brand-icon" />
        <div>
          <h1>Zlux</h1>
          <p>{t('tagline')}</p>
        </div>
      </Link>
      <div className="header-actions">
        {showUpgradePill && (
          <button type="button" className="upgrade-pill" onClick={() => openUpgradeModal('default')}>
            {tSub('upgradePill')}
          </button>
        )}
        <LanguageSwitcher />
        <CurrencySwitcher />
        <NotificationBell />
        <ProfileMenu />
      </div>
    </header>
  );
}

export default Header;
